import * as React from 'react';

import EntityAvatar from 'components/entity/entity-avatar/EntityAvatar';
import Popover from 'components/popover/Popover';
import Link from 'libs/router/Link';

import { trackShippingAddressPopupMenu } from 'modules/tracking/utils/tracking';

import { getEntityFromProfile } from 'utils/view';
import { __t, applyTranslations } from 'utils/language';
import { isInfluencerProfileRejected } from 'utils/profile';

import type { SubcampaignInfluencerProfile } from 'types';

import './shipping-addresses-name.scss';

applyTranslations(require('./shipping-addresses-name.i18n.json'));

type Props = {
  campaignId: number,
  subcampaignId: number,
  influencer: SubcampaignInfluencerProfile
};

const ShippingAddressesName = ({
  influencer,
  campaignId,
  subcampaignId
}: Props) => {
  const entity = getEntityFromProfile(influencer);

  const nameComponent = (
    <div className="shipping-addresses-name__name text-overflow-ellipsis">
      {influencer.name}
    </div>
  );

  return (
    <div className="shipping-addresses-name">
      <EntityAvatar
        entity={entity}
        link={entity?.url}
        customSize={{ width: 24, height: 24 }}
        openInNewTab
        bordered
      />
      <div className="shipping-addresses-name__text-block">
        <Popover
          triggerComponent={nameComponent}
          classNameTrigger="shipping-addresses__name-text-ellipsis"
        >
          <div className="shipping-addresses-name__tooltip">
            {nameComponent}
            <Link
              className="shipping-addresses-name__popup-link"
              target="_blank"
              to={`/content-creator/profiles/${influencer.id}`}
              onClick={() => trackShippingAddressPopupMenu('profile')}
            >
              {__t('shipping_addresses_name.profile_link')}
            </Link>
            <Link
              className="shipping-addresses-name__popup-link"
              target="_blank"
              to={`/campaigns/${campaignId}/subcampaigns/${subcampaignId}`}
              onClick={() => trackShippingAddressPopupMenu('tasks')}
            >
              {__t('shipping_addresses_name.tasks_link')}
            </Link>
            {
              !isInfluencerProfileRejected(influencer) && (
                <Link
                  className="shipping-addresses-name__popup-link"
                  target="_blank"
                  to={`/campaigns/${campaignId}/messages?subcampaignId=${subcampaignId}`}
                  onClick={() => trackShippingAddressPopupMenu('messages')}
                >
                  {__t('shipping_addresses_name.message_link')}
                </Link>
              )
            }
          </div>
        </Popover>
      </div>
    </div>
  );
};

export default ShippingAddressesName;
